// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "docommand/v1/do_command.proto" (package "docommand.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Favorite DoCommand
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { FavoriteDoCommandService } from "./do_command";
import type { ReorderFavoriteDoCommandsResponse } from "./do_command";
import type { ReorderFavoriteDoCommandsRequest } from "./do_command";
import type { ListFavoriteDoCommandsResponse } from "./do_command";
import type { ListFavoriteDoCommandsRequest } from "./do_command";
import type { RemoveFavoriteDoCommandResponse } from "./do_command";
import type { RemoveFavoriteDoCommandRequest } from "./do_command";
import type { RenameFavoriteDoCommandResponse } from "./do_command";
import type { RenameFavoriteDoCommandRequest } from "./do_command";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AddFavoriteDoCommandResponse } from "./do_command";
import type { AddFavoriteDoCommandRequest } from "./do_command";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service docommand.v1.FavoriteDoCommandService
 */
export interface IFavoriteDoCommandServiceClient {
    /**
     * @generated from protobuf rpc: AddFavoriteDoCommand(docommand.v1.AddFavoriteDoCommandRequest) returns (docommand.v1.AddFavoriteDoCommandResponse);
     */
    addFavoriteDoCommand(input: AddFavoriteDoCommandRequest, options?: RpcOptions): UnaryCall<AddFavoriteDoCommandRequest, AddFavoriteDoCommandResponse>;
    /**
     * @generated from protobuf rpc: RenameFavoriteDoCommand(docommand.v1.RenameFavoriteDoCommandRequest) returns (docommand.v1.RenameFavoriteDoCommandResponse);
     */
    renameFavoriteDoCommand(input: RenameFavoriteDoCommandRequest, options?: RpcOptions): UnaryCall<RenameFavoriteDoCommandRequest, RenameFavoriteDoCommandResponse>;
    /**
     * @generated from protobuf rpc: RemoveFavoriteDoCommand(docommand.v1.RemoveFavoriteDoCommandRequest) returns (docommand.v1.RemoveFavoriteDoCommandResponse);
     */
    removeFavoriteDoCommand(input: RemoveFavoriteDoCommandRequest, options?: RpcOptions): UnaryCall<RemoveFavoriteDoCommandRequest, RemoveFavoriteDoCommandResponse>;
    /**
     * @generated from protobuf rpc: ListFavoriteDoCommands(docommand.v1.ListFavoriteDoCommandsRequest) returns (docommand.v1.ListFavoriteDoCommandsResponse);
     */
    listFavoriteDoCommands(input: ListFavoriteDoCommandsRequest, options?: RpcOptions): UnaryCall<ListFavoriteDoCommandsRequest, ListFavoriteDoCommandsResponse>;
    /**
     * @generated from protobuf rpc: ReorderFavoriteDoCommands(docommand.v1.ReorderFavoriteDoCommandsRequest) returns (docommand.v1.ReorderFavoriteDoCommandsResponse);
     */
    reorderFavoriteDoCommands(input: ReorderFavoriteDoCommandsRequest, options?: RpcOptions): UnaryCall<ReorderFavoriteDoCommandsRequest, ReorderFavoriteDoCommandsResponse>;
}
/**
 * @generated from protobuf service docommand.v1.FavoriteDoCommandService
 */
export class FavoriteDoCommandServiceClient implements IFavoriteDoCommandServiceClient, ServiceInfo {
    typeName = FavoriteDoCommandService.typeName;
    methods = FavoriteDoCommandService.methods;
    options = FavoriteDoCommandService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: AddFavoriteDoCommand(docommand.v1.AddFavoriteDoCommandRequest) returns (docommand.v1.AddFavoriteDoCommandResponse);
     */
    addFavoriteDoCommand(input: AddFavoriteDoCommandRequest, options?: RpcOptions): UnaryCall<AddFavoriteDoCommandRequest, AddFavoriteDoCommandResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddFavoriteDoCommandRequest, AddFavoriteDoCommandResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RenameFavoriteDoCommand(docommand.v1.RenameFavoriteDoCommandRequest) returns (docommand.v1.RenameFavoriteDoCommandResponse);
     */
    renameFavoriteDoCommand(input: RenameFavoriteDoCommandRequest, options?: RpcOptions): UnaryCall<RenameFavoriteDoCommandRequest, RenameFavoriteDoCommandResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<RenameFavoriteDoCommandRequest, RenameFavoriteDoCommandResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoveFavoriteDoCommand(docommand.v1.RemoveFavoriteDoCommandRequest) returns (docommand.v1.RemoveFavoriteDoCommandResponse);
     */
    removeFavoriteDoCommand(input: RemoveFavoriteDoCommandRequest, options?: RpcOptions): UnaryCall<RemoveFavoriteDoCommandRequest, RemoveFavoriteDoCommandResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveFavoriteDoCommandRequest, RemoveFavoriteDoCommandResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListFavoriteDoCommands(docommand.v1.ListFavoriteDoCommandsRequest) returns (docommand.v1.ListFavoriteDoCommandsResponse);
     */
    listFavoriteDoCommands(input: ListFavoriteDoCommandsRequest, options?: RpcOptions): UnaryCall<ListFavoriteDoCommandsRequest, ListFavoriteDoCommandsResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListFavoriteDoCommandsRequest, ListFavoriteDoCommandsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReorderFavoriteDoCommands(docommand.v1.ReorderFavoriteDoCommandsRequest) returns (docommand.v1.ReorderFavoriteDoCommandsResponse);
     */
    reorderFavoriteDoCommands(input: ReorderFavoriteDoCommandsRequest, options?: RpcOptions): UnaryCall<ReorderFavoriteDoCommandsRequest, ReorderFavoriteDoCommandsResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReorderFavoriteDoCommandsRequest, ReorderFavoriteDoCommandsResponse>("unary", this._transport, method, opt, input);
    }
}
